module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_pot-ec1351ea07c885abcbd026c2e7cd0f41.png";